import { render } from "./BIPV_Modul.vue?vue&type=template&id=aa57a35c"
import script from "./BIPV_Modul.vue?vue&type=script&lang=js"
export * from "./BIPV_Modul.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__